import { useCallback, useState } from 'react'

export const useListingModals = () => {
  // Modal states
  const [stateInfoModalOpen, setStateInfoModalOpen] = useState(false)
  const [soldOutModalOpen, setSoldOutModalOpen] = useState(false)
  const [showSizeGuideModal, setShowSizeGuideModal] = useState(false)
  const [modalImages, setModalImages] = useState<string[]>([])
  const [modalCurrentIndex, setModalCurrentIndex] = useState(0)

  // Event handlers
  const handleStateInfoModalOpen = useCallback(() => {
    setStateInfoModalOpen(true)
  }, [])

  const handleSoldOut = useCallback(() => {
    setSoldOutModalOpen(true)
  }, [])

  const handleImageModalOpen = useCallback(
    (images: string[], currentIndex: number = 0) => {
      setModalImages(images)
      setModalCurrentIndex(currentIndex)
    },
    []
  )

  const handleImageModalClose = useCallback(() => {
    setModalImages([])
    setModalCurrentIndex(0)
  }, [])

  return {
    // Modal states
    stateInfoModalOpen,
    setStateInfoModalOpen,
    soldOutModalOpen,
    setSoldOutModalOpen,
    showSizeGuideModal,
    setShowSizeGuideModal,
    modalImages,
    modalCurrentIndex,
    setModalCurrentIndex,

    // Handlers
    handleStateInfoModalOpen,
    handleSoldOut,
    handleImageModalOpen,
    handleImageModalClose,
  }
}
